import React from 'react'

import { Card } from '../../components/layout/Card'
import { NotesProvider } from './context'
import { notesPropTypes } from './propTypes'
import { Header } from './components/Header'
import { Views } from './Views'

export const Notes = (props) =>
  <NotesProvider {...props}>
    <Card className='scenario-notes'>
      <Header />
      <Views />
    </Card>
  </NotesProvider>

Notes.propTypes = notesPropTypes
